import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { activitySearchSchema } from "@/features/activity/activity-search"
import { ActivityLog } from "@/features/activity/components/activity-log"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/settings/organisation/activity/"
)({
  validateSearch: activitySearchSchema,
  component: OrganisationActivityPage,
})

function OrganisationActivityPage() {
  const filters = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <>
      <PageHeader title="Activity log" />
      <ActivityLog
        subject={{ type: "organisation" }}
        filters={filters}
        onFiltersChange={(search) => {
          void navigate({ replace: true, search })
        }}
      />
    </>
  )
}
